import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Wrench, Loader2, Wallet, MoonStar } from "lucide-react";
import { http, errMsg } from "../../lib/api";

export const RepairsPanel = () => {
  const [cr, setCr] = useState(null);
  const [rs, setRs] = useState({});
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => {
    http.get("/ops/credits").then((r) => setCr(r.data)).catch(() => {});
    http.get("/ops/retry-all").then((r) => setRs(r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    if (rs.status !== "running") return undefined;
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, [rs.status, load]);
  const post = async (url, msg) => {
    setBusy(true);
    try { const r = await http.post(url); toast.success(msg(r.data)); load(); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  const low = cr?.low;
  return (
    <section data-testid="repairs-panel" className="mb-6 flex flex-wrap items-center gap-3 rounded-lg border border-stone-200 bg-white p-4">
      <Wrench size={18} className="text-[#9A7B2C]" />
      <b className="text-[#2B2A26]">Repairs</b>
      <span data-testid="credit-balance" className={`inline-flex items-center gap-1 text-sm ${low ? "font-bold text-red-600" : "text-stone-500"}`}>
        <Wallet size={13} /> AI balance {cr?.balance == null ? "unknown" : `$${cr.balance.toFixed(2)}`}{low ? ` — below your $${cr.floor} floor, big runs are paused` : ` · big runs pause below $${cr?.floor ?? 10}`}
      </span>
      {rs.status && <span data-testid="retry-all-status" className="text-xs text-stone-500">Restart run: {rs.status}{rs.done ? ` · ${rs.done} job(s) restarted` : ""}{rs.note ? ` · ${rs.note}` : ""}</span>}
      <div className="ml-auto flex gap-2">
        <button data-testid="nightly-run-btn" disabled={busy} onClick={() => post("/ops/nightly/run", () => "Checking every live kit now — results show on each kit")}
          className="inline-flex items-center gap-1.5 rounded-sm border border-stone-300 px-3 py-1.5 text-xs font-bold text-stone-700 hover:bg-stone-50 disabled:opacity-50"><MoonStar size={12} /> Run nightly check now</button>
        <button data-testid="retry-all-btn" disabled={busy || low || rs.status === "running"} onClick={() => post("/ops/retry-all", (x) => (x.jobs ? `Restarting ${x.jobs} stopped job(s)` : "Nothing to restart"))}
          className="inline-flex items-center gap-1.5 rounded-sm bg-[#C9A847] px-3 py-1.5 text-xs font-bold text-white hover:bg-[#B8973A] disabled:opacity-50">
          {(busy || rs.status === "running") && <Loader2 size={12} className="animate-spin" />} Retry all stopped
        </button>
      </div>
    </section>
  );
};
